import { SyntheticEvent } from 'react';

import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';

export type ArchiveAudienceConfirmDialogProps = {
  onClose: (event: SyntheticEvent) => void;
  onConfirm: (event: SyntheticEvent) => void;
  loading: boolean;
  audienceName: string;
};

export const ArchiveAudienceConfirmDialog: React.FC<ArchiveAudienceConfirmDialogProps> = ({
  onClose,
  onConfirm,
  loading,
  audienceName,
}) => {
  return (
    <ConfirmDialog
      dialogTitle='Archive Audience'
      onClose={onClose}
      open
      maxWidth='xs'
      confirmButtonText='Archive'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
        color: 'error',
      }}
    >
      {loading && <LinearProgress />}
      <Typography>{`Are you sure you would like to archive "${audienceName}"?`}</Typography>
    </ConfirmDialog>
  );
};
